import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
    :root {
    font-family: "montserrat", sans-serif;
    background-color: #d9d9d9;
    margin-left: 250px;
    }
`;
